import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation CreateAssetCase($companyId: ID!, $attributes: AssetCaseAttributes!) {
    createAssetCase(companyId: $companyId, attributes: $attributes) {
      assetCase {
        id
        ...CreatedAssetCase
      }
      errors {
        path
        message
      }
    }
  }

  fragment CreatedAssetCase on AssetCase {
    id
    description
    height
    length
    warehouse {
      id
    }
    weight
    width
  }
`
